module.exports = __webpack_public_path__ + "img/Economic.e1fe033e.png";